module.exports = __webpack_public_path__ + "media/images/features/support/eyecatch-type-02-dc98957554b8c9680aef480fb8496794.svg";